import { render, staticRenderFns } from "./activityDialog.vue?vue&type=template&id=5d1b7026&scoped=true"
import script from "./activityDialog.vue?vue&type=script&lang=js"
export * from "./activityDialog.vue?vue&type=script&lang=js"
import style0 from "./activityDialog.vue?vue&type=style&index=0&id=5d1b7026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b7026",
  null
  
)

export default component.exports